import useDatasHooks from "@/main-page/ctls/hooks/useDatasHooks";
import useWatchHooks from "@/main-page/hooks/useWatchHooks";
import {useGridTableStore} from "@/store/modules/gridTableStore";
import {useComDataInterface} from "@/main-page-base/ctls/dataCtls/xmRelQuery/interface/useComDataInterface";
import {initTreeData} from "xmgoing-utils";

export function useDataDealHooks({clickRecord,emits,events,dataConfig, props, queryParams = {},parseFun}:any) {

  const gridTableStore: any = useGridTableStore();
  const showLoading = ref(false);

  //接口方法
  const {
    afterLoadData
  } = useComDataInterface({emits, events});


  const {
    initCtlData,
    tableDs,
    loadingFlag,
    pageTotal,
  }: any = useDatasHooks({dataConfig, pageSize:unref(props).pageSize || (unref(dataConfig) && unref(dataConfig).pageSize),queryData:true});
  /**
   *
   */
  const initCtlDataFun = (inParams={}) => {
    initCtlData(({res}: any) => {
      //如果不是分页查询 就是res
      if (Array.isArray(res)) {
        if(unref(dataConfig).treeData){
          res=initTreeData(res.map((v) => {
            return {...v, key: v.id,};
          }), [],{key: 'id', parentKey: 'parentId'});
        }
        tableDs.value = res;
        parseFun&&parseFun(unref(tableDs));
      } else {
        if (res) {
          let {total, records} = res;
          if(unref(dataConfig).treeData){
            records=initTreeData(records.map((v) => {
              return {...v, key: v.id,};
            }), [],{key: 'id', parentKey: 'parentId'});
          }
          if (records) {
            pageTotal.value = total||records.length;
            tableDs.value = records;
          }else{
            tableDs.value = [res];
          }
          parseFun&&parseFun(unref(tableDs));
        }
      }
      afterLoadData&&afterLoadData(unref(tableDs));
      setTimeout(()=>{
        if(unref(props).onMountedSel){
          if(unref(tableDs)&&unref(tableDs).length>0){
            clickRecord&&clickRecord(unref(tableDs)[0]);
          }
        }
      },50)
      loadingFlag.value = false;
    }, {...unref(queryParams), ...inParams})
    setTimeout(() => {
      loadingFlag.value = false;
    }, 1000)
  }
//监听查询参数变化
  watch(queryParams, (newVal) => {
    nextTick(() => {
      initCtlDataFun({});
    })
  })
  useWatchHooks({initCtlData: initCtlDataFun, dataConfig});
  //如果需要的是全局变量 则还是需要加载
  if(unref(dataConfig)&&!unref(dataConfig).autoLoadData&&unref(dataConfig)['dateQueryType']==='vuexDef'&&unref(dataConfig)['vuexName']){
      initCtlDataFun({});
  }



  if(!(unref(props).loadData!==false&& unref(dataConfig)&&unref(dataConfig).autoLoadData!==false)){
    setTimeout(()=>{
      showLoading.value=false;
      loadingFlag.value=false;
    },300)
  }
  //刷新数据
  const flushList = function (params) {
    initCtlDataFun({...params});
  }

  const tableObj = ref(gridTableStore.getGridObjByKey(unref(props).key));
  if(unref(tableObj)){
    watch(()=>unref(tableObj)['clearCtlDate'],()=>{
      tableDs.value = [];
    })
  }


  return {
    initCtlDataFun,
    loadingFlag,
    pageTotal,
    flushList,
    tableDs,
    showLoading
  }
}
